module.exports = __webpack_public_path__ + "media/images/lb/386-3231ee00f737a4e7d54073aed11b4a72.svg";